/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidPaidParcels200,
  GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidPaidParcels401,
  GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidPaidParcels500,
  GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidPaidParcelsPathParams,
  GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidPaidParcelsQueryParams,
  GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidPaidParcelsQueryResponse,
} from "../../types/individualPaymentPaymentHistoryController/GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidPaidParcels.ts";
import { individualPaymentParcelViewModelSchema } from "../individualPaymentParcelViewModelSchema.ts";

export const getApiV1IndividualpaymentCourseRegistrationsCourseregistrationidPaidParcelsPathParamsSchema =
  z.object({
    courseRegistrationId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidPaidParcelsPathParams>;

export const getApiV1IndividualpaymentCourseRegistrationsCourseregistrationidPaidParcelsQueryParamsSchema =
  z.object({
    financialPersonId: z.optional(z.coerce.number().int()),
    year: z.optional(z.coerce.number().int()),
    culture: z.string().default("pt-BR"),
  }) as unknown as ToZod<GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidPaidParcelsQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1IndividualpaymentCourseRegistrationsCourseregistrationidPaidParcels200Schema =
  z.array(
    z.lazy(() => individualPaymentParcelViewModelSchema),
  ) as unknown as ToZod<GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidPaidParcels200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1IndividualpaymentCourseRegistrationsCourseregistrationidPaidParcels401Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidPaidParcels401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1IndividualpaymentCourseRegistrationsCourseregistrationidPaidParcels500Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidPaidParcels500>;

export const getApiV1IndividualpaymentCourseRegistrationsCourseregistrationidPaidParcelsQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1IndividualpaymentCourseRegistrationsCourseregistrationidPaidParcels200Schema,
  ) as unknown as ToZod<GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidPaidParcelsQueryResponse>;
